define.alias("shared/helpers/get-attachment-url", "settings/helpers/get-attachment-url");